export default "__VITE_ASSET__CRR10F1s__"